module.exports = __webpack_public_path__ + "static/img/v1.01362bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v1.jpg
// module id = DluQ
// module chunks = 1